import React from 'react';
import { TextField, Box } from '@mui/material';

export default function DateRangePicker({ dateFrom, dateTo, onChangeFrom, onChangeTo }) {
  const invalidRange = dateFrom && dateTo && dateTo < dateFrom;

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <TextField
        size="small"
        type="date"
        label="From"
        value={dateFrom}
        onChange={(e) => onChangeFrom(e.target.value)}
        InputLabelProps={{ shrink: true }}
        inputProps={{ max: dateTo || undefined }}
      />
      <TextField
        size="small"
        type="date"
        label="To"
        value={dateTo}
        onChange={(e) => onChangeTo(e.target.value)}
        InputLabelProps={{ shrink: true }}
        error={invalidRange}
        helperText={invalidRange ? 'To must be on or after From' : null}
        inputProps={{ min: dateFrom || undefined }}
      />
    </Box>
  );
}
